import React, { forwardRef } from "react";
import { outboundLink } from "../lib/Analytics";

const OutboundLink = ({
    id = null,
    href,
    title = null,
    style = null,
    className = null,
    targetBlank = true,
    onClick = f => f,
    children,
    trackLink = true,
    disabled = false,
    ...otherProps  // Capture remaining props like data-source-id
  }) => {
  const cn = className ? `${className}${disabled ? " disabled" : ""}` : disabled ? "disabled" : null;
  // The `title` HTML attribute must be a string. Markdown link titles sometimes
  // arrive as booleans (the interpolator falls back to `false` for non-property
  // expressions; some callers pass through `true`/`false` from entity props),
  // which makes React warn "Received `true` for a non-boolean attribute".
  const safeTitle = typeof title === "string" ? title : undefined;
  return (href && <a
    {...(id && { id })}
    target={targetBlank ? "_blank" : null}
    rel="noopener noreferrer"
    title={safeTitle}
    href={href}
    style={style}
    className={cn}
    {...otherProps}  // Forward data-* attributes and other props
    onClick={e => {
      if (!disabled) {
        if (trackLink) {
          outboundLink({label: href}, () => {
          });
        }
        onClick(e);
      }
    }}
  >
    {children}
  </a>)
         || (<span {...(id && {id })} title={safeTitle} className={className}>{children}</span>);
};

export default OutboundLink;
